import groupsPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  isAddGroupDialogueOpen: false,
  isAddGroupMemberDialogueOpen: false,
  editGroup: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [groupsPageActionTypes.GROUPS_PAGE_TOGGLE_DIALOGUE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isAddGroupDialogueOpen: action.isOpen,
    };
  },
  [groupsPageActionTypes.GROUPS_PAGE_TOGGLE_INVITE_MEMBER_DIALOGUE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isAddGroupMemberDialogueOpen: action.isOpen,
    };
  },
  [groupsPageActionTypes.GROUPS_PAGE_SET_GROUP_TO_EDIT]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      editGroup: action.group,
    };
  },
});

export default reducer;
